import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { DesignMode, getDesignTokens } from './designTokens';

type DesignSurfaceProps = BoxProps & {
  elevated?: boolean;
  mode?: DesignMode;
};

export const DesignSurface = ({
  elevated = false,
  mode = 'light',
  sx,
  children,
  ...props
}: DesignSurfaceProps) => {
  const tokens = getDesignTokens(mode);

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        isolation: 'isolate',
        border: `1px solid ${
          mode === 'light' ? 'rgba(29,29,31,0.08)' : 'rgba(255,255,255,0.12)'
        }`,
        borderRadius: tokens.radius.lg,
        background: elevated
          ? mode === 'light'
            ? 'linear-gradient(180deg, rgba(255,255,255,0.96), rgba(250,250,252,0.9))'
            : 'linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.045))'
          : mode === 'light'
            ? 'linear-gradient(180deg, rgba(255,255,255,0.88), rgba(250,250,252,0.74))'
            : 'linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))',
        boxShadow: elevated
          ? mode === 'light'
            ? 'inset 0 1px 0 rgba(255,255,255,0.98), 0 18px 54px rgba(0,0,0,0.09)'
            : 'inset 0 1.5px 0 rgba(255,255,255,0.24), inset 0 -1px 0 rgba(0,0,0,0.24), inset -24px -22px 44px rgba(255,255,255,0.09), 0 18px 48px rgba(0,0,0,0.32)'
          : mode === 'light'
            ? 'inset 0 1px 0 rgba(255,255,255,0.92), 0 10px 30px rgba(0,0,0,0.055)'
            : 'inset 0 1.5px 0 rgba(255,255,255,0.14), inset 0 -1px 0 rgba(0,0,0,0.2)',
        backdropFilter: 'blur(18px) saturate(150%)',
        WebkitBackdropFilter: 'blur(18px) saturate(150%)',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: -1,
          borderRadius: 'inherit',
          background:
            mode === 'light'
              ? 'linear-gradient(180deg, rgba(255,255,255,0.58), rgba(255,255,255,0) 54%)'
              : 'linear-gradient(180deg, rgba(255,255,255,0.09), rgba(255,255,255,0) 58%)',
          pointerEvents: 'none'
        },
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
